import { Box, Flex, useMantineTheme } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import ManageAgentJobs from "src/components/manageAgentJobs";

export const ManageAgentJobsRoute = () => {
    const navigate = useNavigate();
    const _theme = useMantineTheme();

    useEffect(() => {
        if (window.location.hash === "#/manageAgentJobs") {
            navigate({ to: "/manageAgentJobs" });
        }
    }, [navigate]);

    return (
        <Flex p="xl" direction="column" gap="md">
            <Box>
                <ManageAgentJobs />
            </Box>
        </Flex>
    );
};
